"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderNav = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
;
var HeaderNav = function (_a) {
    var navLinks = _a.navLinks, _b = _a.customClasses, customClasses = _b === void 0 ? "" : _b;
    return (react_1.default.createElement("nav", { className: "axxes-header__topbar__nav ".concat(customClasses) },
        react_1.default.createElement("ul", null, navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (link, index) { return (react_1.default.createElement("li", { key: index },
            react_1.default.createElement("h5", null,
                react_1.default.createElement(react_router_dom_1.Link, { to: link.url }, link.name)))); }))));
};
exports.HeaderNav = HeaderNav;
